import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  organizationsDetails: [],
  refreshOrgAndAdminDetails: false
};

export const organizationsSlice = createSlice({
  name: 'organizations',
  initialState,
  reducers: {
    addOrganizationsDetails: (state, action) => {
      if (action?.payload?.length > 0) {
        state.organizationsDetails = [...action.payload];
      }
    },
    clearOrganizationsDetails: (state) => {
      state.organizationsDetails = [];
    },
    triggerRefreshOrgAndAdminDetails: (state, action) => {
      state.refreshOrgAndAdminDetails = action.payload;
    }
  }
});

export const {
  addOrganizationsDetails,
  clearOrganizationsDetails,
  triggerRefreshOrgAndAdminDetails
} = organizationsSlice.actions;

export default organizationsSlice.reducer;
